import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import S from 'constants/string.const';

import CN from './RebookAppointmentModal.module.scss';

const CheckoutButton = ({ width, onCheckout }) => (
  <Button variant="primaryForce" onClick={onCheckout} xSpace width={width}>
    CHECKOUT
  </Button>
);

const BackToTodayButton = ({ width, onToday }) => (
  <Button variant="outlineForce" onClick={onToday} xSpace width={width}>
    BACK TO TODAY
  </Button>
);

const ViewNewBookingButton = ({ width, onClose }) => (
  <Button variant="outlineForce" onClick={onClose} xSpace width={width}>
    VIEW NEW BOOKING
  </Button>
);

const RebookAppointmentModal = ({ isOpen, onToday, onView, onCheckout, hideCheckout }) => (
  <SalonModal tag="RebookAppointmentModal" isOpen={isOpen} withFooter>
    <SalonModal.Body>
      <IconStatus variant="success" width="lg" position="left">
        <Icon variant="confirm" width="xl" />
      </IconStatus>
      <div className={CN.modalContent}>
        <div className={CN.modalTitle}>Appointment Rebooked</div>
        <div className={CN.modalText}>Now you can:</div>
        <div className={CN.modalBullet}>{S.dot} Return to today in your diary</div>
        <div className={CN.modalBullet}>{S.dot} View your rebooked appointment</div>
        <div className={CN.modalBullet}>
          {S.dot} Checkout today{S.apos}s appointment
        </div>
      </div>
    </SalonModal.Body>
    <SalonModal.Footer>
      <div className={CN.desktopOrder}>
        <div className={CN.firstRow}>
          <BackToTodayButton onToday={onToday} />
          <ViewNewBookingButton onClose={onView} />
        </div>
        {!hideCheckout && <CheckoutButton onCheckout={onCheckout} />}
      </div>
      <div className={CN.mobileOrder}>
        <div className={CN.firstRow}>
          <div className={CN.half}>
            <BackToTodayButton width="fluid" onToday={onToday} />
          </div>
          {!hideCheckout && (
            <div className={CN.half}>
              <CheckoutButton width="fluid" onCheckout={onCheckout} />
            </div>
          )}
        </div>
        <ViewNewBookingButton width="fluid" onClose={onView} />
      </div>
    </SalonModal.Footer>
  </SalonModal>
);

export default RebookAppointmentModal;
